
// For local state tracking (Redux slice)

import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "viewedProducts";
const TTL = 1000 * 60 * 60 * 24; // 24 hours
const MAX_ITEMS = 10;

const getStored = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);

    // Filter out expired items
    const now = Date.now();
    const fresh = parsed.filter((item) => now - item.timestamp < TTL);
    return fresh;
  } catch {
    return [];
  }
};

const initialState = {
  products: getStored(),
};

const viewedProductsSlice = createSlice({
  name: "viewedProducts",
  initialState,
  reducers: {
    addViewedProduct: (state, action) => {
      const product = action.payload;
      if (!product || !product._id) return;

      const now = Date.now();
      const existing = state.products.filter((p) => p._id !== product._id);
      const updated = [{ ...product, timestamp: now }, ...existing].slice(0, MAX_ITEMS);

      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      state.products = updated;
    },
    clearViewedProducts: (state) => {
      localStorage.removeItem(STORAGE_KEY);
      state.products = [];
    },
  },
});

export const { addViewedProduct, clearViewedProducts } = viewedProductsSlice.actions;
export default viewedProductsSlice.reducer;
